export const ASSIGN = 'ASSIGN';
export const UNASSIGN = 'UNASSIGN';

export type SprintScopeChangeDirection = typeof ASSIGN | typeof UNASSIGN;
